import { render, staticRenderFns } from "./FundAnnounce.vue?vue&type=template&id=33e6158c&scoped=true&"
import script from "./FundAnnounce.vue?vue&type=script&lang=js&"
export * from "./FundAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./FundAnnounce.vue?vue&type=style&index=0&id=33e6158c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6158c",
  null
  
)

export default component.exports